<template>
  <div class="modalUploadFolder">
    <div id="modalUploadFolder" class="modal fade" data-backdrop="static">
      <div class="modal-dialog modal-dialog-vertical-center modal-lg">
        <div class="modal-content bd-0 tx-14">
          <modal-loading :show="modalLoading"></modal-loading>
          <div v-if="loading" class="upload-loading-mask">
            <div class="upload-loading">
              <div class="upload-bar">
                <div class="bar">
                  <div class="text">
                    {{ successNum }} / {{ uploadFiles.length }}
                  </div>
                  <div
                    class="bg"
                    :style="{
                      width: (successNum / uploadFiles.length) * 100 + '%',
                    }"
                  ></div>
                </div>
                <p v-if="uploadError">
                  {{ $t("outside.上传失败，") }}
                  <a
                    class="mg-r-15 tx-primary"
                    href="javascript:;"
                    @click="reUpload"
                    >{{ $t("outside.重试") }}</a
                  >
                  <a
                    class="mg-r-15 tx-danger"
                    href="javascript:;"
                    @click="cancelUPload"
                    >{{ $t("outside.取消") }}</a
                  >
                </p>
                <p v-else>{{ $t("outside.图片上传中, 请勿关闭当前窗口") }}</p>
              </div>
            </div>
          </div>
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("outside.商品图片批量上传") }}
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pd-25 model-auto-h">
            <div class="row tx-12">
              <div class="col-7">
                <p class="mg-b-5">
                  {{
                    $t(
                      "outside.一次选择多个文件夹批量上传（每个文件夹自动创建一个相册目录）"
                    )
                  }}
                </p>
                <div class="upload-wrap">
                  <template v-if="items.length">
                    <ul class="folders-ul">
                      <li
                        v-for="spu in items"
                        :key="spu.name"
                        :class="{
                          disabled: spuCheckBoxStatus(spu),
                          'none-select': !spuSize(spu),
                        }"
                      >
                        <label>
                          <input
                            class="mg-r-5"
                            type="checkbox"
                            :checked="spuAllChecked(spu)"
                            :disabled="spuCheckBoxStatus(spu)"
                            @change="selectSpu(spu, $event)"
                          />
                          <div class="name spu tx-ellipsis1">
                            <a href="javascript:;" @click="openSpu(spu)">
                              <svg v-if="spu.open" class="iconfont icons">
                                <use xlink:href="#icon-color-folder-open"></use>
                              </svg>
                              <svg v-else class="iconfont icons">
                                <use xlink:href="#icon-color-folder"></use>
                              </svg>
                            </a>
                            {{ spu.name }}
                            <span v-if="spuSize(spu)" class="tx-gray-600"
                              >({{ spuSize(spu) }} M)</span
                            >
                          </div>
                        </label>
                        <ul v-show="spu.open" class="images-ul">
                          <li
                            v-for="item in spu.skus"
                            :key="item.name"
                            :class="{
                              disabled:
                                item.size > maxSize ||
                                !item.isImg ||
                                !item.checked,
                            }"
                          >
                            <label>
                              <input
                                v-if="item.size > maxSize || !item.isImg"
                                class="mg-r-5"
                                type="checkbox"
                                disabled
                              />
                              <input
                                v-else
                                class="mg-r-5"
                                type="checkbox"
                                v-model="item.checked"
                              />
                              <svg class="iconfont icons mg-r-5">
                                <use
                                  :xlink:href="
                                    item.isImg
                                      ? '#icon-color-img'
                                      : '#icon-color-file'
                                  "
                                ></use>
                              </svg>
                              <span class="name tx-ellipsis1 mg-r-5">{{
                                item.name
                              }}</span>
                              <span v-if="item.isImg" class="mg-r-5 tx-gray-600"
                                >({{ toMb(item.size) }} M)</span
                              >
                              <span v-if="!item.isImg" class="tx-danger">
                                {{ $t("outside.(不是图片)") }}
                              </span>
                              <span
                                v-if="item.isImg && item.size > maxSize"
                                class="tx-danger"
                              >
                                {{ $t("outside.(文件超过5MB)") }}
                              </span>
                            </label>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </template>
                  <template v-else>
                    <button
                      type="button"
                      class="upload-btn btn btn-primary"
                      @click="uploadOpen()"
                    >
                      {{ $t("outside.选择上传文件夹") }}
                    </button>
                    <input
                      type="file"
                      id="uploadFolder"
                      webkitdirectory
                      @change="fileChange($event)"
                    />
                  </template>
                </div>
                <div v-if="items.length" class="aciton">
                  <div>
                    {{ $t("outside.已选择") }}
                    <span class="tx-primary">{{ spuLen }}</span>
                    {{ $t("outside.个目录，") }}
                    <span class="tx-primary">{{ imgLen }}</span>
                    {{ $t("outside.张图片。 上传完成后， 图片将会占用") }}
                    <span class="tx-primary">{{ totalSize }}</span
                    >MB。
                  </div>
                  <div v-if="errorFilesLen" class="mg-b-10">
                    {{ $t("outside.不符合要求文件") }}
                    <span class="tx-danger">{{ errorFilesLen }}</span>
                    {{ $t("outside.个") }}
                  </div>
                  <div>
                    <label class="ckbox d-flex align-items-center">
                      <input type="checkbox" v-model="syncSpu" />
                      <span>
                        {{
                          $t(
                            "outside.以文件夹名称自动匹配新品推荐SPU编号自动更新"
                          )
                        }}{{ isSku ? "SKU" : "SPU" }}{{ $t("outside.图片")
                        }}<br />
                        {{
                          $t(
                            "outside.(如果未匹配到SPU或图片匹配失败，将仅作为相册图片完成上传)"
                          )
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <ol>
                  <li>
                    <h3>1.{{ $t("outside.上传规则：") }}</h3>
                    <p>
                      {{ $t("outside.每个相册最多上传") }}{{ maxUpload
                      }}{{ $t("outside.张图片") }}
                    </p>
                    <p>
                      {{ $t("outside.普通上传一次最多可上传") }}{{ maxAllUpload
                      }}{{ $t("outside.张") }}
                    </p>
                    <p>{{ $t("outside.单张最大5MB") }}</p>
                    <p>
                      {{
                        $t(
                          "outside.原始图片宽高超过1920像素时，系统会自动对图片进行等比例压缩"
                        )
                      }}
                    </p>
                  </li>
                  <li>
                    <h3>2.{{ $t("outside.支持格式：") }}</h3>
                    <p>
                      jpg,jpeg,bmp,png,gif
                      {{ $t("outside.(超过2M的gif图片将会丢失动画效果)") }}
                    </p>
                  </li>
                </ol>
                <div>
                  <div class="p-bar">
                    <p>
                      {{ $t("outside.您的相册空间享有") }} {{ maxSpace }}
                      {{ $t("outside.容量") }}
                    </p>
                    <div class="bar">
                      <span>{{ usingSpace }} MB / {{ maxSpace }} </span>
                      <div
                        class="bg"
                        :style="{
                          right:
                            usingSpace > maxSpace
                              ? 0
                              : 100 - (usingSpace / maxSpace) * 100 + '%',
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="mg-t-15" v-if="userInfo.setSupplierAlbum != 1">
                  <span class="tx-gray-900">{{
                    $t("outside.相册容量不够用？")
                  }}</span>
                  <a
                    href="javascript:;"
                    class="tx-info mg-l-15"
                    @click="openSet"
                    >{{ $t("outside.立即升级容量") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex justify-content-center">
              <template v-if="items.length">
                <button
                  class="btn btn-primary mg-r-15"
                  type="button"
                  @click="uploadSubmit()"
                >
                  {{ $t("outside.确认上传") }}
                </button>
                <button
                  class="btn btn-danger mg-r-30"
                  type="button"
                  @click="resetModal"
                >
                  {{ $t("outside.清空") }}
                </button>
              </template>
              <button
                class="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                {{ $t("outside.关闭") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <albumSet :open="albumSetOpen" @start_pay="startPay"></albumSet>
    <PayMask :code="payCode" @pay_success="paySuccess"></PayMask>
  </div>
</template>

<script>
import albumSet from "./modal-album-set.vue";
import PayMask from "./pay-mask.vue"; //支付等待遮罩
export default {
  name: "uploadFolder",
  props: ["open", "type", "isSku"],
  data() {
    return {
      //				maxSpace: this.$store.state.maxSpace,
      maxSpace: "",
      maxUpload:
        JSON.parse(localStorage.getItem("userInfo")) &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
          .data &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo.data
          .folderSize
          ? JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
              .data.folderSize
          : 0,
      maxAllUpload:
        JSON.parse(localStorage.getItem("userInfo")) &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
          .data &&
        JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo.data
          .uploadMax
          ? JSON.parse(localStorage.getItem("userInfo")).vipInfoJson.albumInfo
              .data.uploadMax
          : 0,
      modalLoading: false,
      loading: false,
      items: [],
      maxSize: 5 * 1024 * 1024, //最大字节数
      syncSpu: false,
      uploadFiles: [],
      allRounds: 0,
      round: 0,
      usingSpace: 0, //已使用空间mb
      iis: 5,
      uploadError: false,
      uploadingSpu: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      albumSetOpen: Symbol(),
      payCode: "",
    };
  },
  components: {
    albumSet,
    PayMask,
  },
  computed: {
    successNum() {
      if (!this.uploadFiles) {
        return 0;
      }
      let len = 0;
      this.uploadFiles.forEach((file) => {
        if (file.success) {
          len++;
        }
      });
      return len;
    },
    errorFilesLen() {
      let len = 0;
      this.items.forEach((spu) => {
        spu.skus.forEach((e) => {
          if (e.size > this.maxSize || !e.isImg)
            //图片要求
            len++;
        });
      });
      return len;
    },
    totalSize() {
      //总占用空间 Mb
      let size = 0;
      this.items.forEach((spu) => {
        spu.skus.forEach((e) => {
          if (e.size <= this.maxSize && e.isImg && e.checked)
            //图片要求
            size += e.size;
        });
      });
      return (size / 1024 / 1024).toFixed(2);
    },
    imgLen() {
      //多少图片
      let len = 0;
      this.items.forEach((spu) => {
        spu.skus.forEach((e) => {
          if (e.size <= this.maxSize && e.isImg && e.checked)
            //图片要求
            len++;
        });
      });
      return len;
    },
    spuLen() {
      //多少个目录
      let len = 0;
      this.items.forEach((spu) => {
        spu.skus.some((e) => {
          if (e.size <= this.maxSize && e.isImg && e.checked) {
            len++;
            return true;
          }
        });
      });
      return len;
    },
  },
  watch: {
    open() {
      (this.modalLoading = false),
        (this.loading = false),
        (this.items = []),
        (this.syncSpu = false),
        (this.uploadFiles = false),
        (this.allRounds = 0),
        (this.round = 0);
      this.uploadError = false;
      this.uploadingSpu = [];
      this.getSpace();
      if (this.userInfo.setSupplierAlbum == 1) {
        if (Number(this.userInfo.albumSize) == 0) {
          this.maxSpace = this.$t("outside.无限制");
        } else {
          this.maxSpace = Number(this.userInfo.albumSize) * 1024 + "MB";
        }
      } else {
        if (
          this.userInfo.vipInfoJson &&
          this.userInfo.vipInfoJson.albumInfo &&
          this.userInfo.vipInfoJson.albumInfo.data &&
          this.userInfo.vipInfoJson.albumInfo.data.size
        ) {
          this.maxSpace =
            Number(this.userInfo.vipInfoJson.albumInfo.data.size) * 1024 + "MB";
        } else {
          this.maxSpace = 0 + "MB";
        }
      }
    },
  },
  methods: {
    paySuccess(type) {
      if (type) {
        $.api_call("api.User.checkLoginStatus", { checkOverTime: 1 }, (r) => {
          if (r.ErrorCode == "9999") {
            location.reload();
          } else {
            userFailure(this);
          }
        });
      } else {
        location.reload();
      }
    },
    startPay(code) {
      this.payCode = code;
      //    this.payActive = true;
      $("#modalPayMask").modal("show");
      this.payMaskWait = setInterval(() => {
        $.api_call(
          "api.PayRecord.getStatus",
          {
            payCode: code,
          },
          (r) => {
            if (r.ErrorCode == "9999") {
              if (r.Data.Results == "2" || r.Data.Results == "4") {
                $.api_call(
                  "api.User.checkLoginStatus",
                  { checkOverTime: 1 },
                  (r) => {
                    if (r.ErrorCode == "9999") {
                      let DATA = r.Data.Results;
                      localStorage.setItem("apiUserToken", DATA.token);
                      localStorage.setItem("apiUserId", DATA.id);
                      localStorage.setItem(
                        "apiSubUserId",
                        DATA.subUserId ? DATA.subUserId : 0
                      );
                      
                      this.$store.commit('setFTstatus', r.Data.Results.amountStatus)
                      store.set("userInfo", DATA);
                      store.set("isLogging", true);
                      sessionStorage.setItem("isApiSuccess", true);
                      location.reload();
                      clearInterval(this.payMaskWait);
                    } else {
                      userFailure(this);
                    }
                  }
                );
              }
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }, 3000);
    },
    openSet() {
      $("#modalUploadFolder").modal("hide");
      this.albumSetOpen = Symbol();
      $(".modalUploadFolder #modalAlbumSet").modal("show");
    },
    cancelUPload() {
      this.loading = false;
      this.uploadError = false;
      this.uploadFiles = [];
    },
    reUpload() {
      this.uploadError = false;
      this.loading = true;
      this.round = this.iis;
      for (let i = 0; i <= this.iis; i++) {
        this.upLoadApi(i);
      }
    },
    getSpace() {
      $.api_call("api.SupplierAlbum.getSizeByUser", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.usingSpace = r.Data.Results;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    uploadSubmit() {
      //保存上传
      if (this.imgLen > 500) {
        ShowTip(this.$t("outside.一次最多上传500个文件"), "danger");
        return false;
      }
      //重置上传数据
      this.uploadFiles = [];
      this.allRounds = 0;
      this.round = 0;
      //生成上传列表
      let numError = false;
      this.items.forEach((folder) => {
        if (folder.skus.length > this.maxUpload) {
          numError = true;
        }
        folder.skus.forEach((sku) => {
          if (sku.checked && sku.isImg && sku.size <= this.maxSize) {
            //符合上传条件；
            this.uploadFiles.push({
              spu: folder.name,
              file: sku.file,
              fileName: sku.name,
              size: sku.size,
              success: false,
            });
          }
        });
      });
      if (numError) {
        ShowTip(
          this.$t("outside.单个文件夹不能超过") +
            `${this.maxUpload}` +
            this.$t("outside.个文件"),
          "danger"
        );
        this.uploadFiles = [];
        return;
      }
      if (!this.uploadFiles.length) {
        ShowTip(this.$t("outside.没有符合上传条件的文件"), "danger");
        return;
      }
      if (Number(this.totalSize) + this.usingSpace > this.maxSpace) {
        ShowTip(this.$t("outside.您的空间不足"), "danger");
        return;
      }
      this.loading = true;
      this.round = this.iis;
      for (let i = 0; i <= this.iis; i++) {
        this.upLoadApi(i);
      }
    },
    upLoadApi(i) {
      if (this.uploadError) {
        return;
      }
      if (i > this.uploadFiles.length - 1) {
        return;
      }
      //上传
      let fileItem = this.uploadFiles[i];
      if (
        fileItem.success ||
        this.uploadingSpu.some((e) => {
          return e == fileItem.spu;
        })
      ) {
        //已上传成功 或者 有正在上传的目录 跳过(不能并发传同一个name)
        this.round++;
        this.upLoadApi(this.round);
        return;
      }
      this.uploadingSpu.push(fileItem.spu);
      let reader = new FileReader();
      reader.readAsDataURL(fileItem.file);
      reader.onload = (e) => {
        fileItem.base64 = e.target.result;
        let params = {
          name: fileItem.spu,
          imgUrlBase64: fileItem.base64.split("base64,").pop(),
          ext: fileItem.fileName.split(".").pop(),
          size: fileItem.size,
          imgName: fileItem.fileName,
          syncSpu: this.syncSpu,
          type: this.type,
          isEnd: 0,
        };
        let num = 0;
        this.uploadFiles.forEach((e) => {
          if (e.spu == fileItem.spu && !e.success) {
            num++;
          }
        });
        if (num == 1) {
          params.isEnd = 1;
        }
        $.api_call("api.SupplierAlbum.uploadAlbum", params, (r) => {
          //清除正在上传的目录
          this.uploadingSpu.some((e, i) => {
            if (e == params.name) {
              this.uploadingSpu.splice(i, 1);
              return true;
            }
          });
          if (r.ErrorCode == "9999") {
            fileItem.success = true;
            this.round++;
            if (this.round < this.uploadFiles.length) {
              this.upLoadApi(this.round);
            } else {
              //上传结束
              if (this.round - this.iis == this.uploadFiles.length) {
                if (this.successNum == this.uploadFiles.length) {
                  //上传结束
                  this.loading = false;
                  //上传成功结束模态框
                  this.uploadFiles = [];
                  this.$emit("uploadSuccess");
                  ShowTip(this.$t("outside.上传成功"), "success");
                  $("#modalUploadFolder").modal("hide");
                } else {
                  this.reUpload();
                }
              }
            }
          } else {
            this.uploadError = true;
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        });
      };
    },
    openSpu(spu) {
      // 打开关闭spu
      spu.open = !spu.open;
    },
    spuSize(spu) {
      //选中上传的 大小
      let s = 0;
      spu.skus.forEach((sku) => {
        if (sku.checked) s += sku.size;
      });
      if (!s) {
        return 0;
      }
      return (Number(s) / 1024 / 1024).toFixed(2);
    },
    toMb(size) {
      if (isNaN(size)) {
        return 0;
      }
      return (Number(size) / 1024 / 1024).toFixed(2);
    },
    selectSpu(spu, event) {
      //操作spu选择
      spu.skus.forEach((sku) => {
        if (sku.isImg && sku.size <= this.maxSize) {
          sku.checked = event.target.checked;
        }
      });
    },
    spuCheckBoxStatus(spu) {
      //spu checkbox 是否disable
      let isChoosable = false;
      spu.skus.some((sku) => {
        if (sku.isImg && sku.size <= this.maxSize) {
          isChoosable = true;
          return true;
        }
      });
      return !isChoosable;
    },
    spuAllChecked(spu) {
      //spu是否全选
      let [s, len] = [true, 0];
      spu.skus.forEach((sku) => {
        if (sku.isImg && sku.size <= this.maxSize && !sku.checked) {
          s = false;
        }
        if (sku.isImg && sku.size <= this.maxSize) {
          len++;
        }
      });
      return s && len;
    },
    fileChange(event) {
      //上传获取文件
      let files = event.target.files;
      if (!files.length) {
        ShowTip(this.$t("outside.没有可上传的文件"), "danger");
        return;
      }
      this.items = [];
      Object.keys(files).forEach((key) => {
        //目录名
        let spuName =
          files[key].webkitRelativePath.split("/")[
            files[key].webkitRelativePath.split("/").length - 2
          ];
        let fileName = files[key].webkitRelativePath.split("/").pop();
        //创建数组
        if (
          this.items.some((e) => {
            return e.name == spuName;
          })
        ) {
          this.items.some((e) => {
            if (e.name == spuName) {
              e.skus.push({
                name: fileName,
                file: files[key],
                size: files[key].size,
                isImg: files[key].type.indexOf("image") > -1,
                checked:
                  files[key].type.indexOf("image") > -1 &&
                  files[key].size <= this.maxSize,
              });
              return true;
            }
          });
        } else {
          this.items.unshift({
            name: spuName,
            open: true,
            skus: [
              {
                name: fileName,
                file: files[key],
                size: files[key].size,
                isImg: files[key].type.indexOf("image") > -1,
                checked:
                  files[key].type.indexOf("image") > -1 &&
                  files[key].size <= this.maxSize,
              },
            ],
          });
        }
      });
      event.target.value = "";
    },
    resetModal() {
      this.items = [];
      this.syncSpu = false;
    },
    uploadOpen() {
      document.getElementById("uploadFolder").click();
    },
  },
};
</script>

<style lang="less" scoped>
.upload-wrap {
  margin-bottom: 10px;
  padding: 15px;
  position: relative;
  border: 1px #ddd solid;
  height: 300px;
  overflow-y: auto;
  .upload-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .upload-btn + input[type="file"] {
    display: none;
  }
  .folders-ul {
    list-style: none;
    margin: 0;
    padding: 0;
    color: #333;
    > li {
      margin-bottom: 5px;
      > label {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }
    > li.disabled {
      color: #999;
      svg {
        opacity: 0.6;
      }
    }
    > li.none-select {
      color: #999;
    }
    .images-ul {
      list-style: none;
      margin: 0;
      padding: 0;
      > li {
        position: relative;
        padding-left: 35px;
        height: 20px;
        line-height: 20px;
        color: #333;
        > label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
        }
      }
      > li::before {
        position: absolute;
        top: 0;
        left: 25px;
        content: "";
        height: 20px;
        border-left: 1px #ddd dotted;
      }
      > li:last-child::before {
        height: 10px;
      }
      > li::after {
        position: absolute;
        top: 50%;
        left: 25px;
        content: "";
        width: 10px;
        border-top: 1px #ddd dotted;
      }
      > li.disabled {
        color: #999;
        svg {
          opacity: 0.6;
        }
      }
    }
  }
}

.name.tx-ellipsis1 {
  display: inline-block;
  max-width: 165px;
}

.name.spu.tx-ellipsis1 {
  max-width: 320px;
}

ol {
  list-style: none;
  margin: 0 0 20px 0;
  padding: 0 30px 0 0;
  border-bottom: 1px #ddd dashed;
  li {
    margin-bottom: 15px;
    color: #333;
    h3 {
      color: #666;
      font-size: 14px;
    }
    p {
      margin-bottom: 2px;
    }
  }
}

.p-bar {
  p {
    margin-bottom: 2px;
  }
  .bar {
    display: flex;
    justify-content: center;
    position: relative;
    width: 200px;
    border: 1px #17a2b8 solid;
    overflow: hidden;
    span {
      position: relative;
      z-index: 1;
      color: #000;
    }
    > .bg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #17a2b8;
    }
  }
}

.upload-loading-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  background: rgba(255, 255, 255, 0.4);
  .upload-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .upload-bar {
      background-color: #fff;
      padding: 25px;
      box-shadow: 1px 1px 6px #ddd;
      .bar {
        position: relative;
        margin-bottom: 15px;
        width: 460px;
        border: 1px #17a2b8 solid;
        > .text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #333;
        }
        > .bg {
          height: 22px;
          background-color: #17a2b8;
        }
      }
      p {
        margin: 0;
        text-align: center;
        color: #333;
      }
    }
  }
}
</style>